import { TOGGLE_MUST_LOGIN_SCREEN } from "./displayMustLoginScreenReducer"

export const toggleMustLoginScreen = (value) => ({
    type: TOGGLE_MUST_LOGIN_SCREEN,
    payload: value
})